import React from 'react';

export interface SwitchProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  size?: 'sm';
  disabled?: boolean;
  id?: string;
}

export function Switch({ checked, onChange, size, disabled, id }: SwitchProps) {
  return (
    <label
      className={'switch' + (size === 'sm' ? ' switch-sm' : '')}
      htmlFor={id}
    >
      <input
        type="checkbox"
        id={id}
        checked={!!checked}
        disabled={disabled}
        onChange={(e) => onChange && onChange(e.target.checked)}
      />
      <span className="track">
        <span className="thumb" />
      </span>
    </label>
  );
}

export default Switch;
